import React from "react";
import Post from "./Post";
import { useSelector } from "react-redux";
import BlogLayout from "./BlogLayout";

function Posts() {
  const postReducer = useSelector((state) => state.postReducer);
  const { posts, authorName, category } = postReducer;
  console.log(posts);
  // const { author_name } = authorName;
  // console.log(author_name);
  const filters = useSelector((state) => state.filters);

  let debounceFilter = (post) => {
    const { value } = filters;
    console.log(value);
    if (value.length > 0) {
      return post.title.toLowerCase().includes(value.toLowerCase().trim());
    }
    return true;
  };

  return (
    <BlogLayout>
      {posts
        .filter(debounceFilter)
        .filter((post) => {
          if (authorName.length > 0) {
            return post.author_name
              .toLowerCase()
              .includes(authorName.toLowerCase());
          }
          return true;
        })
        .filter((post) => {
          if (category.length > 0) {
            return post.category.includes(category);
          }
          return true;
        })
        .map((post) => (
          <Post key={post.id} {...post} />
        ))}
    </BlogLayout>
  );
}

export default Posts;
